export const imgPasswordVisible = require("../assets/ic_password_visible.png");
export const imgPasswordInVisible = require("../assets/ic_password_invisible.png");
export const passwordUpdateSuccess = require('../assets/update_success.png')
export const imagea = require('../assets/view_B.png');
export const imageb = require('../assets/view_A.png');